import type { FC } from "react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

import { useAuthHrefResolver } from "@ui/providers/AuthRoutingProvider";

import { Loader } from "@jti/core-components/components/Loader";
import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { OlaApi } from "@jti/rest-api";

import styles from "./DoubleOptInRedirect.module.scss";

type DoubleOptInRedirectProps = {
  successPageRedirectUrl: string;
  errorPageRedirectUrl: string;
};

export function DoubleOptIn() {
  return (
    <div className={styles.container}>
      <Loader data-testid="doubleOptInLoader" />
    </div>
  );
}

export const DoubleOptInRedirect: FC<DoubleOptInRedirectProps> = ({ errorPageRedirectUrl }) => {
  const [isMounted, setIsMounted] = useState(false);
  const resolveAuthHref = useAuthHrefResolver();

  useEffect(() => {
    setIsMounted(true);
    const olaApi = OlaApi.init();
    const query = new URLSearchParams(window.location.search);
    olaApi
      .validateHash(query.get("hash") || "")
      .then((res) => {
        if (res.token) {
          window.location.href = resolveAuthHref({
            route: AUTH_ROUTE_PATHS.newPasswordOffline,
            pathSegments: [res.token],
          });
        } else {
          window.location.href = errorPageRedirectUrl;
        }
      })
      .catch(() => {
        window.location.href = errorPageRedirectUrl;
      });
  }, [errorPageRedirectUrl, resolveAuthHref]);

  if (!isMounted) {
    return null;
  }

  return <>{createPortal(<DoubleOptIn />, document.body)}</>;
};
